// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MIC_YEAR_PAGE_LOADING() {
      return {
        isLoading: true,
        micYearPage: action.micYearPage
      };
    },
    MIC_YEAR_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.micYearPage
      };
    },
    MIC_YEAR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYearPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
